import { idbGet, idbPut } from './idb.js';
import { getActivePinKey } from '../state/security/vault.js';

type StoreName = 'chapters' | 'chunks' | 'timing' | 'meta';
type EncryptedBlob = { iv: number[]; ct: number[] };

export async function offlinePut(
  store: StoreName,
  key: string,
  data: ArrayBuffer,
): Promise<void> {
  const pinKey = getActivePinKey();
  if (!pinKey) {
    await idbPut(store, key, data);
    return;
  }
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ct = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, pinKey, data);
  const blob: EncryptedBlob = {
    iv: Array.from(iv),
    ct: Array.from(new Uint8Array(ct)),
  };
  await idbPut(store, key, blob);
}

export async function offlineGet(
  store: StoreName,
  key: string,
): Promise<ArrayBuffer | null> {
  const raw = await idbGet<ArrayBuffer | EncryptedBlob>(store, key);
  if (raw === undefined || raw === null) return null;

  if (raw instanceof ArrayBuffer) return raw;

  const pinKey = getActivePinKey();
  if (!pinKey) return null;
  try {
    return await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: new Uint8Array((raw as EncryptedBlob).iv) },
      pinKey,
      new Uint8Array((raw as EncryptedBlob).ct),
    );
  } catch {
    return null;
  }
}
